import $ from 'jquery';

export default function (iframeSelector, loadingImageSelector) {
  /**
   * Set the height of the iframe to the height of the content by measuring `.html-container`
   * Some embeds, like charts, depend on the height of the iframe to be set first.
   * In those cases we set the height to the available height of the viewport.
   *
   * @param {number} timeout - Timeout in milliseconds before setting the height
   */
  const setHeight = function (timeout) {
    const $iframe = $(iframeSelector);

    if ($iframe.length < 1) {
      return;
    }

    const padding = 75;
    setTimeout(function () {
      const container = $iframe.contents().find('.html-container');
      const viewportHeight = $(window).height();
      const iframePosition = $iframe.offset()?.top || 0;
      const availableHeight = viewportHeight - iframePosition;

      // if the iframe's content is smaller than the available, set the height to the available viewport space
      $iframe.height(
        Math.max(availableHeight - padding, container.height() + padding)
      );
    }, timeout);
  };

  $(iframeSelector).on('load', function () {
    const $iframe = $(iframeSelector);
    if ($iframe.contents().text() === 'generating_snapshot') {
      setTimeout(function () {
        $iframe[0].contentWindow.location.reload();
      }, 2000);
    } else {
      $(loadingImageSelector).remove();
      $iframe.removeClass('loading');
      setHeight(500);
    }
  });

  $(document).on('visibilitychange', function () {
    if (!document.hidden) {
      setHeight(300);
    }
  });
}
